import React from 'react';
import { SpacerProps } from './Spacer.types';
import * as S from './Spacer.styles';

export const Spacer = ({ height = 0, width = 0, testId, backgroundColor }: SpacerProps) => {
  return <S.Spacer data-testid={testId} width={width} height={height} backgroundColor={backgroundColor} />;
};
